// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"1681b74a","189":"2ec1f539","223":"8cf7cb09","419":"879496c7","453":"aac68abc","519":"38b24c7d","592":"a71ceb68","692":"19987845","845":"8de65855"}[chunkId] + ".chunk.js";
};